import { cellNotFilter, esProductoEnMetros, formatDateWithTimeCell, metrosAUnidades, TABLE_CONSTANTS_COLUMS } from "@/shared"

import CustomCantidadRecibidaInput from "@/shared/components/ui/CustomCantidadRecibidaInput"
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral"
import { MaterialTransferido } from "@/shared/interfaces"

import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store"
import { Box, Chip } from "@mui/material"
import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"

export default function useTableRevisionSolicitudPedido() {
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const infoProducto = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      {
        accessorKey: 'cantidad',
        header: 'Cantidad Requerida',
      },
      {
        accessorKey: 'cantidad_aprobada',
        header: 'Cant. A Aprobar',
        Cell: ({ row }) => {
          const cantidaMaxima = Number(row.original.cantidad)
          return (
            <CustomCantidadRecibidaInput
              value={Number(row.original.cantidad_aprobada) || 0}
              maxValue={cantidaMaxima}
              handleValue={(value) => {
                handleActualizarProducto(row.original.id, {
                  ...row.original,
                  cantidad_aprobada: value
                })
              }}
              row={row}
            />

          )
        }
      },
      {
        id: 'cant_aprobada_und',
        header: 'Aprob. (Und)',
        Cell: ({ row }) =>
          esProductoEnMetros(row.original)
            ? `${metrosAUnidades(row.original, Number(row.original.cantidad_aprobada) || 0)} und`
            : '—',
      },
      {
        accessorKey: 'codigo',
        header: 'Código'
      },
      {
        accessorKey: 'producto_data.descripcion',
        header: 'Descripción'
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria'
      },
      {
        accessorKey: 'producto_data.stock_actual',
        header: 'Stock Actual'
      },
      {
        accessorKey: 'producto_data.modelo_producto',
        header: 'Modelo',
        Cell: ({ row }) => row.original?.producto_data?.modelo_producto || 'N/A'
      },
      {
        accessorKey: 'producto_data.marca_producto',
        header: 'Marca',
        Cell: ({ row }) => row.original?.producto_data?.marca_producto || 'N/A'
      },
      {
        accessorKey: 'producto_data.unidad_medida',
        header: 'Medida',
        Cell: ({ row }) => row.original?.producto_data?.unidad_medida || 'N/A'
      }
    ], []
  )
  const columns = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      /* {
        accessorKey: 'cantidad_aprobada',
        header: '',
        Header: () => <>Cant.<br />Aprobada </>,
        size: 130,
        Cell: ({ row }) => {
          const valor = row.original?.cantidad_aprobada ?? 0;
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip label="Aprobada" color="primary" size="small" variant="outlined" />
              <span style={{ fontWeight: 'bold' }}>{valor}</span>
            </Box>
          );
        }
      }, */
      {
        accessorKey: 'cantidad_a_entregar',
        header: 'Cant. A Transferir',
        Header: () => <>Cant. A.<br /> Transferir</>,
        size: 130,
      },
      {
        accessorKey: "producto_data.stock_actual",
        header: "Stock Disponible",
        Header: () => <>Stock<br /> Disponible</>,
        size: 130,
        Cell: ({ row }) => {
          const stock = row.original?.producto_data?.stock_actual ?? "N/A"
          return (
            <Box
              sx={{
                display: 'inline-flex',
                px: 1.2,
                py: 0.4,
                borderRadius: '4px',
                bgcolor: '#48B3AF',
                color: '#fff',
                fontWeight: 600,
                fontSize: '0.8rem',
                minWidth: 40,
                justifyContent: 'center',
              }}
            >
              {stock}
            </Box>
          )
        }
      },
      {
        accessorKey: "codigo",
        header: "Código",
      },
      {
        accessorKey: "producto_data.descripcion",
        header: "Descripción",
      },
      {
        accessorKey: "producto_data.unidad_medida",
        header: "Unidad Medida",
        Cell: ({ row }) => {
          return <Chip
            label={row.original?.producto_data?.unidad_medida || "N/A"}
          />
        }
        //Cell: ({ row }) => row.original?.producto_data?.unidad_medida || "N/A",

      },
      {
        accessorKey: "producto_data.modelo_producto",
        header: "Modelo",
        Cell: ({ row }) => row.original?.producto_data?.modelo_producto || "N/A",
      },
      {
        accessorKey: "producto_data.marca_producto",
        header: "Marca",
        Cell: ({ row }) => row.original?.producto_data?.marca_producto || "N/A",
      },
      {
        accessorKey: "producto_data.categoria_producto",
        header: "Categoría",
        Cell: ({ row }) => row.original?.producto_data?.categoria_producto || "N/A",
      },
      {
        accessorKey: "costo_promedio",
        header: "Costo Histórico",
        size: 140,
      },
      {
        accessorKey: "costo_compra",
        header: "Costo Actual",
        size: 140,
      },

    ], []
  )
  const columnsCompraBase = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      
      {
        accessorKey: 'producto_data.stock_actual',
        header: 'stock disponible',
        Header: () => <>Stock<br />Disponible</>,
        size: 120,
        Cell: ({ row }) => {
          const stock = row.original?.producto_data?.stock_actual
          return (
            <Box
              sx={{
                display: 'inline-flex',
                px: 1.2,
                py: 0.4,
                borderRadius: '4px',
                bgcolor: '#FF90BB',
                color: '#fff',
                fontWeight: 600,
                fontSize: '0.8rem',
                minWidth: 40,
                justifyContent: 'center',
              }}
            >
              {stock} {/* {'Agotado'} */}
            </Box>
          )
        }
      },
      {
        accessorKey: "codigo",
        header: "Código",
      },
      {
        accessorKey: "producto_data.descripcion",
        header: "Descripción",
      },
      {
        accessorKey: "producto_data.unidad_medida",
        header: "Unidad Medida",
        Header: () => <>Unidad<br />Medida</>,
        size: 130,
        Cell: ({ row }) => {
          return <Chip
            label={row.original?.producto_data?.unidad_medida || "N/A"}
          />
        }
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria'
      },
      {
        accessorKey: "producto_data.modelo_producto",
        header: "Modelo",
        Cell: ({ row }) => row.original?.producto_data?.modelo_producto || "N/A",
      },
      {
        accessorKey: "producto_data.marca_producto",
        header: "Marca",
        Cell: ({ row }) => row.original?.producto_data?.marca_producto || "N/A",
      },
      {
        accessorKey: "costo_promedio",
        header: "Costo Histórico",
        size: 140,
      },
      {
        accessorKey: "costo_compra",
        header: "Costo Actual",
        size: 140,
      },

    ], []
  )
  const columnsCompra = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    ()=>[
      {
        accessorKey: 'cantidad_pendiente',
        header: 'Cant. A. Comprar',
        Header: () => <>Cant. A.<br />Comprar</>,
        size: 100,
      },
      ...columnsCompraBase

    ],[]
  )
  const columnsEnviadosAcomprar = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    ()=>[
      {
        accessorKey: 'cantidad_comprar',
        header: 'Cant. A. Comprar',
        Header: () => <>Cant. A.<br />Comprar</>,
        size: 100,
        Cell: ({ row }) => {
          const stock = Number(row.original.producto_data?.stock_actual ?? 0);
          const aprobada = Number(row.original.cantidad_aprobada ?? 0);
          return Math.max(0, aprobada - stock);
        }
      },
      ...columnsCompraBase
    ],[]
  )
  const columnsTrazabilidadPedido = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "solicitud_egreso_data.numero_referencia",
        header: "N° solicitud",
        Cell: ({ row }) => row.original.solicitud_egreso_data?.numero_referencia
      },
      {
        ...cellNotFilter,
        accessorKey: "solicitud_egreso_data.user.username",
        header: "usuario",
        size: 100,
        width: 100,
        //Cell: ({ row }) => row.original?.user?.username || 'N/A'
      },
      {
        ...cellNotFilter,
        accessorKey: "solicitud_egreso_data.bodega_data.nombre",
        header: "bodega",
        size: 200,
        //Cell: ({ row }) => row.original?.bodega_data?.nombre || 'N/A'
      },
      {
        accessorKey: "motivo_rechazo_data.nombre",
        header: "Motivo Rechazo",
        size: 200,
        Cell: ({ row }) => row.original.motivo_rechazo_data?.nombre || 'N/A'
      },
      {
        accessorKey: 'observaciones.observacionRevisionSolicitudPedido',
        header: "Observacion del Revisor",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => {
          return <ModalObservacionGeneral
            texto={
              row.original.observaciones?.observacionRevisionSolicitudPedido || 'N/A'
            }
            title="observación"
          />
        }
        //Cell:({row}) => row.original.observaciones?.observacionRevisionSolicitudPedido || 'N/A'
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_creacion",
        header: "Fecha de creacion",
        size: 200,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion')
      },

    ], []
  )
  const columnsPedidosCompletados = useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
    () => [
      {
        accessorKey: 'estado',
        header: 'Estado',
        //size: 150,
        Cell: ({ row }) => {
          const hayPendientes = row.original.cantidad_pendiente
          return (

            <Chip
              //label="Transferencia completa"
              label={hayPendientes ? 'Transferencia Parcial' : 'Transferencia Completa'}
              color={hayPendientes ? 'warning' : 'success'}
              variant="outlined"
              sx={{
                fontWeight: 'bold',
                fontSize: '0.75rem',
                height: 'auto', '& .MuiChip-label': { whiteSpace: 'normal', textAlign: 'center', lineHeight: 1.2, py: 0.5 }
              }} />
          )

        }
      },
      {
        accessorKey: 'cantidad_aprobada',
        header: 'Cant.Aprobada',
        Header: () => <>Cant.<br />Aprobada</>,
        size: 120,
      },
      {
        accessorKey: 'cantidad_transferido',
        header: 'Cant.',
        Header: () => <>Cant.<br />Transferida</>,
        size: 150
        //header: 'Cant.Transferida'
      },
      {
        accessorKey: "codigo",
        header: "Código",
      },
      {
        accessorKey: "producto_data.descripcion",
        header: "Descripción",
      },
      {
        accessorKey: "producto_data.unidad_medida",
        header: "Unidad Medida",
        Cell: ({ row }) => {
          return <Chip
            label={row.original?.producto_data?.unidad_medida || "N/A"}
          />
        }
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria'
      },
      {
        accessorKey: "producto_data.modelo_producto",
        header: "Modelo",
        Cell: ({ row }) => row.original?.producto_data?.modelo_producto || "N/A",
      },
      {
        accessorKey: "producto_data.marca_producto",
        header: "Marca",
        Cell: ({ row }) => row.original?.producto_data?.marca_producto || "N/A",
      },
      {
        accessorKey: "costo_promedio",
        header: "Costo Histórico",
        size: 140,
      },
      {
        accessorKey: "costo_compra",
        header: "Costo Actual",
        size: 140,
      },

    ], []

  )
  return {
    infoProducto,
    columns,
    columnsCompra,
    columnsTrazabilidadPedido,
    columnsPedidosCompletados,
    columnsEnviadosAcomprar
  }
}